import { i18n } from 'i18n';
import {
  ContentItem,
  FileParameter,
  FileResponse
} from './api';
import { makeCreateMutation, makeGetQuery } from './useApi';

const CONTENT_ITEMS_KEY = 'content-items';
const IMAGE_UPLOAD_KEY = 'image-upload';
const IMAGE_FEEDBACK_KEY = 'image-download';

export const useCreateContentItemMutation = makeCreateMutation<void, ContentItem>(
  CONTENT_ITEMS_KEY,
  // The generated client renamed this operation to postApiContent and it now resolves to void; the
  // feedback flow only reacts to success/error, so nothing consumed the old FileResponse.
  (api) => (contentItem) => api.contentApi.postApiContent(contentItem, true),
  () => i18n._('Feedback created successfully'),
);

export const useAddImageMutation = makeCreateMutation<string, FileParameter>(
  IMAGE_UPLOAD_KEY,
  (api) => (file) => api.users.uploadUserfeedbackImage(file),
  () => i18n._('Image uploaded successfully'),
);

export const useImageFeedbackQuery = makeGetQuery<FileResponse, string>(
  IMAGE_FEEDBACK_KEY,
  (api, url) => () => api.users.getUserfeedbackImage(url),
);
